export default __webpack_public_path__ + "static/media/key.0eb5efc8.svg";